import { NgModule } from "@angular/core";
import { RouterModule, Route } from "@angular/router";
import { EBEnrolleeDashboardComponent } from "./component/eb-enrollee-dashboard/eb-enrollee-dashboard.component";
import { EbClaimHistoryComponent } from "./component/eb-claim-history/eb-claim-history.component";
import { EBDashboardMemberAndBenefitComponent } from "./component/eb-dashboard-member-and-benefit/eb-dashboard-member-and-benefit.component";

const routes: Route[] = [
    {
        path: "employee-dashboard",
        component: EBEnrolleeDashboardComponent
    },
    {
        path: "claim-history",
        component: EbClaimHistoryComponent
    },
    {
      path: "eb-dashboard-member-and-benefit",
      component: EBDashboardMemberAndBenefitComponent
    },
    {
      path: "eb-dashboard-member-and-benefit/:productId",
      component: EBDashboardMemberAndBenefitComponent
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule { }
